import { useState } from 'react';

interface HeaderProps {
  lang: 'pt' | 'en';
  setLang: (lang: 'pt' | 'en') => void;
}

const navLinks = {
  pt: [
    { label: 'Serviços', id: 'servicos' },
    { label: 'Problema', id: 'problema' },
    { label: 'Resultados', id: 'casos' },
    { label: 'Contacto', id: 'contacto' },
  ],
  en: [
    { label: 'Services', id: 'servicos' },
    { label: 'Problem', id: 'problema' },
    { label: 'Results', id: 'casos' },
    { label: 'Contact', id: 'contacto' },
  ],
};

function Header({ lang, setLang }: HeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const links = navLinks[lang];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-sm">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between w-full">
          {/* Logo */}
          <a
            href="#"
            onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            className="text-2xl text-white tracking-wide hover:text-purple-400 transition-all duration-300 font-light cursor-pointer whitespace-nowrap no-underline"
            style={{ fontFamily: "'Share Tech', sans-serif" }}
          >
            SimplesFlow
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {links.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={(e) => { e.preventDefault(); scrollToSection(link.id); }}
                className="text-white/80 hover:text-white transition-colors text-sm font-light cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Right side: toggle + mobile menu btn */}
          <div className="flex items-center gap-4">
            {/* PT | EN Toggle Pill */}
            <div className="flex items-center bg-white/10 rounded-full p-0.5 border border-white/20">
              <button
                onClick={() => setLang('pt')}
                className={`px-3 py-1 rounded-full text-xs font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  lang === 'pt'
                    ? 'bg-white text-black'
                    : 'text-white/70 hover:text-white'
                }`}
              >
                PT
              </button>
              <button
                onClick={() => setLang('en')}
                className={`px-3 py-1 rounded-full text-xs font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  lang === 'en'
                    ? 'bg-white text-black'
                    : 'text-white/70 hover:text-white'
                }`}
              >
                EN
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-white/80 hover:text-white transition-colors cursor-pointer"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className={`text-xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="absolute top-full left-0 right-0 bg-black/95 backdrop-blur-md border-t border-white/10 md:hidden">
            <div className="px-6 py-4 space-y-4">
              {links.map((link) => (
                <a
                  key={link.id}
                  href={`#${link.id}`}
                  onClick={(e) => { e.preventDefault(); scrollToSection(link.id); }}
                  className="block w-full text-left text-white/80 hover:text-white transition-colors text-sm font-light cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
